// This file was automatically generated from ext.onboarding.accountForm.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ext.onboarding.accountForm');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ext.onboarding.accountForm.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<h1>View Your Data When It\'s Ready</h1><form id="onboarding-account-form"><div class="spacer"></div><h4 class="el8HeaderNoBorder">Create Your Elation Health Account</h4><div class="spacer5"><p class="el8AppColor el8FieldLabelTop">Email address:</p><div class="el8OBTextareaWrapValidation"><input type="text" class="" name="email" /></div></div><div class="spacer5"><p class="el8AppColor el8FieldLabelTop">New password:</p><div class="el8OBTextareaWrapValidation"><div class="error-msg el8FieldValidationText el8AlertText" data-name="password1"></div><input type="password" class="" name="password1" /></div></div><div class="spacer5"><p class="el8AppColor el8FieldLabelTop">Confirm password:</p><div class="el8OBTextareaWrapValidation"><div class="error-msg el8FieldValidationText el8AlertText" data-name="password2"></div><input type="password" class="" name="password2" /></div></div><div class="spacer"></div><h4 class="el8HeaderNoBorder">Identify Challenge Questions To Recover Your Password</h4><div class="spacer5"><div class="el8Wrap el8FieldValidationMargin"><select name="challenge1" data-type="challengeQ">');
  el8.template.ext.onboarding.accountForm.challengeQList(soy.$$augmentData(opt_data, {num: 1}), output);
  output.append('</select></div><div class="el8OBTextareaWrapValidation"><textarea name="challengeAnswer1" class=""></textarea></div></div><div class="spacer5"><div class="el8Wrap el8FieldValidationMargin"><select name="challenge2" data-type="challengeQ">');
  el8.template.ext.onboarding.accountForm.challengeQList(soy.$$augmentData(opt_data, {num: 2}), output);
  output.append('</select></div><div class="el8OBTextareaWrapValidation"><textarea name="challengeAnswer2" class=""></textarea></div></div><div class="spacer5"><div class="el8Wrap el8FieldValidationMargin"><select name="challenge3" data-type="challengeQ">');
  el8.template.ext.onboarding.accountForm.challengeQList(soy.$$augmentData(opt_data, {num: 3}), output);
  output.append('</select></div><div class="el8OBTextareaWrapValidation"><textarea name="challengeAnswer3" class=""></textarea></div></div></form>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ext.onboarding.accountForm.challengeQList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<option class="" value="">- Select Challenge Question #', soy.$$escapeHtml(opt_data.num), ' -</option>');
  var qList10417 = opt_data.challengeQs;
  var qListLen10417 = qList10417.length;
  for (var qIndex10417 = 0; qIndex10417 < qListLen10417; qIndex10417++) {
    var qData10417 = qList10417[qIndex10417];
    output.append('<option class="" value="', soy.$$escapeHtml(qData10417), '">', soy.$$escapeHtml(qData10417), '</option>');
  }
  if (!opt_sb) return output.toString();
};
